import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const FormatsPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const getData = (count = 5, offset = 0) => {
    apiRequests.events.getFormats(count, offset).then((res) => setData(res));
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.events.getFormatsFiltered(searchValue).then((res) => setData(res));
    }
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = (id) => {
    apiRequests.events.deleteFormat(id).then(() =>
      setData((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск форматов..."
        createLink="/events/formats/create"
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`/events/formats/${item.id}`}
              localizationLink={`/events/formats/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={data.totalCount}
        itemsPerPage={5}
        onChange={(page) => getData(5, 5 * page)}
      />
    </>
  );
};

export default FormatsPage;
